import React, { useEffect, useState } from 'react';
import SearchInput from '../../../../../../shared/design-system/components/atoms/search-input';
import { IconPlace } from '../../../../../../shared/design-system/components/dropdown';

type SearchProps = {
  isSearched: boolean;
  onSearch?: (searchValue: string, key: string, onClear?: boolean) => void;
  tabKey: string;
  isTemplateRequestPending: boolean;
};

const Search: React.FC<SearchProps> = ({
  isSearched,
  onSearch,
  tabKey,
  isTemplateRequestPending,
}) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [isSearching, setIsSearching] = useState<boolean>(true);

  const searchHandler = () => {
    onSearch(searchValue, tabKey);
  };

  const onClearSearch = () => {
    onSearch('', tabKey, true);
  };

  useEffect(() => {
    if (isTemplateRequestPending) {
      setIsSearching(true);
    }

    if (isSearched && !isTemplateRequestPending && isSearching) {
      setIsSearching(false);
    }
  }, [isSearched, isSearching, isTemplateRequestPending]);

  return (
    <div className="search-wrapper pl-4 pr-4 mb-3">
      <SearchInput
        onSearch={searchHandler}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        className="search-input-field"
        onClearSearch={onClearSearch}
        searchIconPlace={IconPlace.Left}
        placeholder="Search here..."
        hideClear={true}
      />
    </div>
  );
};

export default Search;
